import React from 'react';
import styled from 'styled-components';
import { UserState } from '../../../../utils/apollo/graphqlSchema';

interface IProps {
  state: UserState;
}

const Container = styled.div`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
`;

const userStatusLookup: Record<
  UserState,
  { label: string; labelColor: string; bgColor: string }
> = {
  [UserState.Active]: {
    label: 'Active',
    labelColor: '#017018',
    bgColor: '#eaf3ec',
  },
  [UserState.Pending]: {
    label: 'Pending',
    labelColor: '#ffc400',
    bgColor: '#fffaeb',
  },
  [UserState.Deleted]: {
    label: 'Disabled',
    labelColor: '#ff3b30',
    bgColor: '#ffefee',
  },
};

const UserStatus = ({ state }: IProps) => {
  const { label, labelColor, bgColor } = userStatusLookup[state];

  return (
    <Container style={{ color: labelColor, backgroundColor: bgColor }}>
      {label}
    </Container>
  );
};

export default UserStatus;
